import React from 'react';
import __ from 'lodash';

class DdKurikulum extends React.Component{
    render(){
        return (
            this.props.kurikulum.map((val) =>
                <option key={val.id_kurikulum} value={val.id_kurikulum}>{val.nama_kurikulum}</option>
            )            
        )
    }
}

export default DdKurikulum;